import React, { Component } from 'react';
import PropTypes from 'prop-types'
import Drawer from '../Common/Drawer/Drawer';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';
import InputText from '../Common/InputText';
import Toggle from '../Common/Toggle/Toggle';

export class FiltersDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = Object.assign({}, props.searchParams);
    }


    onFormChange = (name, value) => {
        this.setState({ [name]: value});
    }

    onTextChange = (e) => {
        this.onFormChange(e.target.name, e.target.value);
    }

    onDropdownChange = (csv, name) => {

        const arrayOfSelectedIds = csv.split(",");
        const objectsWithIds = [];
        if (arrayOfSelectedIds != "") {
            for (let i = 0; i < arrayOfSelectedIds.length; i++) {
                objectsWithIds.push({
                    id: arrayOfSelectedIds[i]
                })
            }
        }

        this.onFormChange(name, objectsWithIds);
    }

    onApply = () => {
        this.props.onComplete(this.state);
    }

    render() {

        const departmentIds = this.state.departments.map(m => m.id);
        const baselineJobTitleIds = this.state.baselineJobTitles.map(m => m.id);
        const communityIds = this.state.communities.map(m => m.id);
        const phaseIds = this.state.phases.map(m => m.id);
        const disciplineIds = this.state.disciplines.map(m => m.id);

        return (
            <Drawer isWide={true} title='Baseline Task List Filters'
                onSaveClick={this.onApply}
                saveText='Apply'
                onCancelClick={this.props.onCancel}>

                <div className="row">
                    <div className="col-12">
                        <InputText name="name" label="Name" type="text" placeholder="Name" value={this.state.name} onChange={this.onTextChange} isRequired={false} />
                    </div>
                    <div className="col-12">
                        <InputText name="additionalInfo" label="Additional Info" type="text" placeholder="Additional Info" value={this.state.additionalInfo} onChange={this.onTextChange} isRequired={false} />
                    </div>
                    <div className="col-12">
                        <Toggle name="isActive" text="Active" checked={this.state.isActive} onChange={this.onFormChange} />
                    </div>
                    <div className="col-12">
                        <MultiSelectBox name="departments" label="Departments" idField="id" valueField="name" options={this.props.departments} selectedValues={departmentIds.toString()} onChange={this.onDropdownChange} isMulti={true} />
                    </div>
                    <div className="col-12">
                        <MultiSelectBox name="baselineJobTitles" label="Baseline Job Titles" idField="id" valueField="name" options={this.props.baselineJobTitles} selectedValues={baselineJobTitleIds.toString()} onChange={this.onDropdownChange} isMulti={true} />
                    </div>
                    <div className="col-12">
                        <MultiSelectBox name="communities" label="Communities" idField="id" valueField="name" options={this.props.communities} selectedValues={communityIds.toString()} onChange={this.onDropdownChange} isMulti={true} />
                    </div>
                    <div className="col-12">
                        <MultiSelectBox name="phases" label="Phases" idField="id" valueField="name" options={this.props.phases} selectedValues={phaseIds.toString()} onChange={this.onDropdownChange} isMulti={true} />
                    </div>
                    <div className="col-12">
                        <MultiSelectBox name="disciplines" label="Disciplines" idField="id" valueField="name" options={this.props.disciplines} selectedValues={disciplineIds.toString()} onChange={this.onDropdownChange} isMulti={true} />
                    </div>
                </div>
            </Drawer>
        )
    }
}

FiltersDrawer.propTypes = {
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    searchParams: PropTypes.object.isRequired,
    departments: PropTypes.array.isRequired,
    baselineJobTitles: PropTypes.array.isRequired,
    communities: PropTypes.array.isRequired,
    phases: PropTypes.array.isRequired,
    disciplines: PropTypes.array.isRequired,
};

export default FiltersDrawer;
